const fetchBodyParts = async (
  modalityId: string,
  locationId?: string | null
) => {
  const url = new URL(
    `/api/v1/modalities/${modalityId}/body_parts`,
    window.location.origin
  );

  if (locationId) {
    url.searchParams.set("location_id", locationId);
  }

  const response = await fetch(url.toString(), {
    headers: {
      Accept: "application/json",
    },
    credentials: "same-origin",
  });

  if (!response.ok) {
    throw new Error("Failed to fetch body parts");
  }

  const payload = await response.json();
  return payload.body_parts || [];
};

export default fetchBodyParts;
